export default "__VITE_ASSET__CulWe8fP__"